import { Component, computed, ElementRef, inject, input } from '@angular/core';
import { GameService } from '@core/game/game.service';
import { IDraggable } from '@features/drag-and-drop/drag-and-drop.types';
import { LpActionsService } from '@features/lp/lp-actions/lp-actions.service';
import { ILpCanvasElementContext } from '@features/lp/lp-canvas/lp-canvas.types';
import { LpDropTargetDirective } from '@features/lp/lp-drag-and-drop/lp-drop-target.directive';
import { workaroundPivot } from '@shared/workarounds.utils';
import { LpDropTargetCanvasComponent } from '@typings/lp/generated';

@Component({
  selector: 'lp-drop-target-canvas-component',
  imports: [LpDropTargetDirective],
  templateUrl: './lp-drop-target-canvas-component.component.html',
  styleUrl: './lp-drop-target-canvas-component.component.css',
})
export class LpDropTargetCanvasComponentComponent {
  readonly _gameService = inject(GameService);
  readonly #lpActionsService = inject(LpActionsService);
  readonly el = inject<ElementRef<HTMLElement>>(ElementRef);

  comp = input.required<LpDropTargetCanvasComponent>();
  context = input.required<ILpCanvasElementContext>();

  pivot = computed(() => workaroundPivot(this.context().element().pivot));

  async onAdded(draggable: IDraggable) {
    await this.#lpActionsService.perform(this.comp().onDraggableAdded);
  }

  async onRemoved(draggable: IDraggable) {
    await this.#lpActionsService.perform(this.comp().onDraggableRemoved);
  }
}
